import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcm-course-in-nagpur',
  templateUrl: './mcm-course-in-nagpur.component.html',
  styleUrls: ['./mcm-course-in-nagpur.component.scss']
})
export class McmCourseInNagpurComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
